"use client";

import { BlurFade } from "@/components/ui/blur-fade";
import { Badge } from "@/components/ui/badge";
import Image from "next/image";

interface Logo {
  name: string;
  logo?: string;
}

interface LogoCloudProps {
  title?: string;
  logos: Logo[];
}

const LogoCloud = ({ title, logos }: LogoCloudProps) => {
  if (!logos || logos.length === 0) return null;

  return (
    <section className="py-16 px-6 bg-muted/50">
      <div className="container max-w-5xl mx-auto flex flex-col items-center gap-8">
        {title && (
          <BlurFade delay={0.1}>
            <p className="text-sm font-semibold text-foreground/40 uppercase tracking-widest">
              {title}
            </p>
          </BlurFade>
        )}

        <BlurFade delay={0.2}>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {logos.map((logo, i) => (
              <div key={i} className="flex items-center justify-center">
                {logo.logo ? (
                  <div className="h-8 md:h-10 w-auto opacity-40 hover:opacity-70 transition-opacity grayscale">
                    <Image
                      src={logo.logo}
                      alt={logo.name}
                      width={120}
                      height={40}
                      className="h-full w-auto object-contain"
                    />
                  </div>
                ) : (
                  <Badge
                    variant="secondary"
                    className="text-xs md:text-sm font-semibold px-4 py-2 bg-white border border-foreground/10 text-foreground/50 hover:text-foreground/70 transition-colors rounded-full"
                  >
                    {logo.name}
                  </Badge>
                )}
              </div>
            ))}
          </div>
        </BlurFade>
      </div>
    </section>
  );
};

export default LogoCloud;
